import { Context } from "urql";
import { Logger } from "@lululemon/ecom-pdp/src/utils/logger";
import { publicConfig } from "@lululemon/ecom-core";
import { KIWI_PATH } from "./constants";
import Util from "../lib/util";

const storeInventoryQuery = `
  query GetStoreInventory($skus: [String!]!, $storeIds: [String!]!, $country: Country) {
    storeInventory(skus: $skus, storeIds: $storeIds, country: $country) {
      stores {
        inventory {
          quantity
          bopisQuantity
          skuId
        }
        storeId
      }
      status {
        code
      }
    }
  }
`;

const fetchStoreInventory = async (graphqlClient, skus, storeIds) => {
  try {
    const country = Util.getShippingLocation();
    const apiHost = `${publicConfig?.apiHost}`;
    Context.url = `${apiHost}${KIWI_PATH}`;

    const { data, errors } = await graphqlClient
      .query(
        storeInventoryQuery,
        {
          skus,
          storeIds,
          country,
        },
        Context
      )
      .toPromise();

    if (errors) {
      throw errors;
    }

    if (data?.storeInventory?.status?.code >= 400) {
      Logger.error(
        `Error fetching storeInventory response, failed with status code: ${data?.storeInventory?.status?.code}`,
        {
          isRedirect: false,
        }
      );
    }

    return data?.storeInventory;
  } catch (error) {
    Logger.error(`Error fetching storeInventory response`, {
      isRedirect: false,
      error,
    });
  }
};

export default fetchStoreInventory;
